import {
  Heading,
  Icon,
  Skeleton,
  Tbody,
  Td,
  Text,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { MdOutlineSearchOff } from "react-icons/md";

interface TableStateProps {
  noOfCols: number;
  noOfRows?: number;
}

export function LoadingDataTable({ noOfCols, noOfRows = 10 }: TableStateProps) {
  return (
    <Tbody data-testid="data-table-loading-body">
      {Array.from({ length: noOfRows }).map((_, index) => (
        <Tr key={index}>
          <Td colSpan={noOfCols}>
            <Skeleton height="1rem" />
          </Td>
        </Tr>
      ))}
    </Tbody>
  );
}

export interface EmptyResultStateProps {
  errorTitle?: string;
  errorIconElement?: ReactNode;
  errorSubTitle?: string;
}

export function EmptyResultState({
  noOfCols,
  errorTitle,
  errorIconElement,
  errorSubTitle,
}: TableStateProps & EmptyResultStateProps) {
  return (
    <Tbody>
      <Tr>
        <Td py="5rem" colSpan={noOfCols}>
          <VStack as="span" alignItems="center" color="surface.600" w="full">
            {errorIconElement ? (
              <>{errorIconElement}</>
            ) : (
              <Icon as={MdOutlineSearchOff} fontSize="7rem" />
            )}
            <Heading size="md" fontFamily="sans-serif">
              {errorTitle ? <>{errorTitle}</> : "No result Found"}
            </Heading>
            {errorSubTitle && <Text>{errorSubTitle}</Text>}
          </VStack>
        </Td>
      </Tr>
    </Tbody>
  );
}
